"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrictionForce = void 0;
const force_1 = require("@/simulator/force");
const vector_1 = require("@/simulator/vector");
class FrictionForce extends force_1.Force {
    constructor(_support, _friction) {
        super(0, 0);
        this._support = _support;
        this._friction = _friction;
        this.origin = this._support.origin;
        this._maxStaticFrictionSize = this._support.length * this._friction; // f = N * μ
    }
    update(self) {
        super.update(self);
        if (self.velocity.isZero()) {
            this.x = this.y = 0;
            return;
        }
        const vertical = new vector_1.Vector(-this._support.y, this._support.x).getUnitVector();
        const velocityComponent = self.velocity.getComponent(vertical);
        if (!velocityComponent.isZero()) { // Dynamic friction
            const friction = vector_1.Vector.multiplyScalar(vector_1.Vector.reverse(velocityComponent).getUnitVector(), this._maxStaticFrictionSize);
            this.x = friction.x;
            this.y = friction.y;
            // If in the next frame, the friction force will cause the velocity of the object reverse,
            // then set the friction and the velocity to 0.
            const frictionAccelerate = force_1.Force.from(friction).getAccelerate(self.mass);
            if (vector_1.Vector.multiply(vector_1.Vector.add(velocityComponent, frictionAccelerate), velocityComponent) <= 0) {
                this.x = this.y = 0;
                self.velocity.x = self.velocity.y = 0;
            }
        }
        else { // Static friction
            const forceComponent = self.forces.getComponent(vertical);
            const friction = vector_1.Vector.reverse(forceComponent);
            if (friction.length <= this._maxStaticFrictionSize) {
                this.x = friction.x;
                this.y = friction.y;
            }
            else { // Max static friction
                const maxFriction = vector_1.Vector.multiplyScalar(friction.getUnitVector(), this._maxStaticFrictionSize);
                this.x = maxFriction.x;
                this.y = maxFriction.y;
            }
        }
    }
    /** @deprecated */
    static from(_arg) {
        throw new Error("Cannot create a friction force via from().");
    }
    static create(support, friction) {
        return new FrictionForce(support, friction);
    }
}
exports.FrictionForce = FrictionForce;
